import { api } from "../App";
import { SET_DOCUMENT_JOURNAL_LIST, SET_DOCUMENT_JOURNAL_BY_ID, SET_DOCUMENT_JOURNAL_LOADING } from "./types";


export const createIntegration = ({ name, ...body }) => async (dispatch, getState) => {
  let success
  try {
    // dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: true });
    const { data } = await api.post(`/integration_exchange/${name}`, body);
    success = true
  } catch (ERR) {
  } finally {
    // dispatch({ type: SET_DOCUMENT_JOURNAL_LOADING, payload: false });
    return success
  }
}
